export const currencyOptions = ['EUR', 'USD', 'GBP', 'CAD', 'AUD'].map((currencyCode) => ({
    value: currencyCode,
    label: currencyCode,
}));
